// import axios from "axios";

// const API_BASE = process.env.REACT_APP_USER_SERVICE_URL + "/admins/sellers";

// /**
//  * Fetch sellers with HATEOAS pagination
//  * @param {Object} options
//  * @param {number} options.page
//  * @param {number} options.size
//  * @param {string} options.search
//  * @param {string} options.role
//  */
// export async function fetchSellers({
//   token,
//   page = 0,
//   size = 10,
//   search,
//   role,
// } = {}) {
//   const params = { page, size };
//   if (search) params.search = search;
//   if (role) params.role = role;

//   try {
//     const res = await axios.get(API_BASE, {
//       params,
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     });
//     const data = res.data;

//     const embedded = data._embedded ?? {};
//     const sellers = embedded.adminSellerResponseList ?? [];

//     return {
//       sellers: sellers.map((seller) => ({
//         id: seller.id,
//         fullName: seller.fullName,
//         email: seller.email,
//         phone: seller.phone,
//         status: seller.status,
//         roles: seller.roles,
//         addresses: seller.addresses,
//         companyName: seller.companyName,
//         businessLicensePath: seller.businessLicensePath,
//         licenseUploadedAt: seller.licenseUploadedAt,
//         licenseVerified: seller.licenseVerified,
//         licenseVerifiedAt: seller.licenseVerifiedAt,
//         createdAt: seller.createdAt,
//         updatedAt: seller.updatedAt,
//       })),
//       page: data.page,
//       links: data._links,
//     };
//   } catch (err) {
//     console.error("Failed to fetch sellers:", err);
//     return {
//       sellers: [],
//       page: { number: 0, totalPages: 0 },
//       links: {},
//     };
//   }
// }

// // Update seller status
// export async function updateSellerStatus(sellerId, status) {
//   return axios.put(`${API_BASE}/${sellerId}/status`, { status });
// }
// // Verify seller license
// export async function approveSeller(sellerId) {
//   return axios.put(`${API_BASE}/approve/${sellerId}`);
// }

// // Delete seller
// export async function deleteSeller(sellerId) {
//   return axios.delete(`${API_BASE}/${sellerId}`);
// }

import axios from "axios";

const BASE_URL = process.env.REACT_APP_USER_SERVICE_URL;

if (!BASE_URL) {
  throw new Error("Missing REACT_APP_USER_SERVICE_URL");
}

const API_BASE = `${BASE_URL}/admins/sellers`;

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 10000, // 10s timeout (important for mobile networks)
});

/* ---------------- HELPERS ---------------- */

const authHeader = (token) => {
  if (!token) throw new Error("Missing auth token");
  return { Authorization: `Bearer ${token}` };
};

/**
 * Normalize seller safely
 */
const normalizeSeller = (seller = {}) => ({
  id: seller.id ?? "",
  fullName: seller.fullName ?? "N/A",
  email: seller.email ?? "",
  phone: seller.phone ?? "",
  status: seller.status ?? "",
  roles: seller.roles ?? [],
  addresses: seller.addresses ?? [],
  companyName: seller.companyName ?? "",
  businessLicensePath: seller.businessLicensePath ?? "",
  licenseUploadedAt: seller.licenseUploadedAt ?? null,
  licenseVerified: seller.licenseVerified ?? false,
  licenseVerifiedAt: seller.licenseVerifiedAt ?? null,
  createdAt: seller.createdAt ?? null,
  updatedAt: seller.updatedAt ?? null,
});

/* ---------------- FETCH SELLERS ---------------- */

export async function fetchSellers({
  token,
  page = 0,
  size = 10,
  search,
  role,
} = {}) {
  const params = { page, size };

  if (search) params.search = search;
  if (role) params.role = role;

  try {
    const res = await api.get("/admins/sellers", {
      params,
      headers: authHeader(token),
    });

    const data = res.data;

    // Strict validation (no silent failures)
    if (!data || typeof data !== "object") {
      throw new Error("Invalid API response");
    }

    const sellersRaw = data._embedded?.adminSellerResponseList ?? null;

    if (!Array.isArray(sellersRaw)) {
      throw new Error("Invalid HATEOAS structure: sellers missing");
    }

    return {
      sellers: sellersRaw.map(normalizeSeller),
      page: data.page ?? { number: 0, totalPages: 0 },
      links: data._links ?? {},
    };
  } catch (err) {
    console.error("Failed to fetch sellers:", err);

    // Do NOT silently fake empty data
    throw err;
  }
}

/* ---------------- UPDATE STATUS ---------------- */

export async function updateSellerStatus(token, sellerId, status) {
  if (!sellerId) throw new Error("Missing sellerId");
  if (!status) throw new Error("Missing status");

  return api.put(
    `/admins/sellers/${sellerId}/status`,
    { status },
    {
      headers: authHeader(token),
    },
  );
}

/* ---------------- APPROVE SELLER ---------------- */

export async function approveSeller(token, sellerId) {
  if (!sellerId) throw new Error("Missing sellerId");

  return api.put(
    `/admins/sellers/approve/${sellerId}`,
    {},
    {
      headers: authHeader(token),
    },
  );
}

/* ---------------- DELETE SELLER ---------------- */

export async function deleteSeller(token, sellerId) {
  if (!sellerId) throw new Error("Missing sellerId");

  return api.delete(`/admins/sellers/${sellerId}`, {
    headers: authHeader(token),
  });
}
